import React from "react";

const AlertEditorSkeletonLoader: React.FC = () => {
  return (
    <div className="h-full overflow-auto bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <div className="max-w-4xl mx-auto px-6 pt-16 pb-8 min-h-full">
        {/* Header skeleton */}
        <div className="mb-8">
          <div className="flex items-center gap-2 text-gray-600 mb-4">
            <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
          </div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-orange-100 rounded-xl animate-pulse"></div>
            <div>
              <div className="h-8 bg-gray-200 rounded w-32 animate-pulse mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-48 animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Form skeleton */}
        <div className="bg-white rounded-2xl border border-gray-200 p-8 mb-8">
          <div className="space-y-6">
            {/* Alert Name skeleton */}
            <div>
              <div className="h-5 bg-gray-200 rounded w-20 mb-2 animate-pulse"></div>
              <div className="h-12 bg-gray-200 rounded-lg animate-pulse"></div>
            </div>

            {/* Instructions skeleton */}
            <div>
              <div className="h-5 bg-gray-200 rounded w-24 mb-2 animate-pulse"></div>
              <div className="h-32 bg-gray-200 rounded-lg animate-pulse"></div>
            </div>

            {/* Status skeleton */}
            <div>
              <div className="h-5 bg-gray-200 rounded w-12 mb-2 animate-pulse"></div>
              <div className="flex items-center gap-3">
                <div className="h-10 bg-gray-200 rounded-lg w-20 animate-pulse"></div>
                <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Actions skeleton */}
        <div className="flex items-center justify-between">
          <div className="flex gap-3">
            <div className="h-10 bg-gray-200 rounded-lg w-24 animate-pulse"></div>
          </div>
          <div className="h-10 bg-gray-200 rounded-lg w-28 animate-pulse"></div>
        </div>

        {/* Alert History skeleton */}
        <div className="mt-12">
          <div className="h-6 bg-gray-200 rounded w-32 mb-4 animate-pulse"></div>
          <div className="bg-white rounded-2xl border border-gray-200 p-8 text-center">
            <div className="w-12 h-12 bg-gray-200 rounded-xl mx-auto mb-4 animate-pulse"></div>
            <div className="h-5 bg-gray-200 rounded w-32 mx-auto mb-2 animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-64 mx-auto animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertEditorSkeletonLoader;
